export class PrivacySettings {
  showAddress = true;
  showTelephone  = false;
  showEmail = false;
  showOnList = true;
}
